module.exports = __webpack_public_path__ + "img/JOC_2951.1b89546c.jpg";